import React from "react";
import { QRCode } from "antd";
import GiapLaiSeal from "./GiapLaiSeal";

export default function AuditTrailPage({ data, company, showGiapLai = true, customStamp }) {
  const employeeName = data.employeeName || data.staff_name || "Người lao động";
  const managerName = data.managerName || company?.representative || "";
  const contractCode = data.code || "HĐ-CIS";
  const docHash =
    data.documentHash ||
    data.document_hash ||
    (data.id ? `cis-${data.id}-${Date.now().toString(16)}` : "Đang chờ hoàn tất giao kết");
  const verifyUrl = `http://localhost:3000/verify-contract/${data.id || "preview"}`;

  return (
    <div
      className="audit-trail-page contract-page-section"
      style={{
        pageBreakBefore: "always",
        fontFamily: "'Times New Roman', serif",
        color: "#111",
        background: "#fff",
        padding: "40px 50px",
        borderTop: "2px solid #cbd5e1",
        marginTop: 40,
        position: "relative",
      }}
    >
      {/* Dấu giáp lai cho trang biên bản chứng nhận điện tử */}
      <GiapLaiSeal
        company={company}
        customStamp={customStamp || data?.seal_image || data?.sealImage}
        pageNumber="Biên bản"
        data={data}
        visible={showGiapLai}
      />

      {/* Khung viền chứng thư trang trọng */}
      <div
        style={{
          border: "2px solid #0f172a",
          padding: "30px",
          borderRadius: 4,
          position: "relative",
          background: "#fafafa",
        }}
      >
        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: 24, borderBottom: "1px solid #cbd5e1", paddingBottom: 16 }}>
          <div style={{ fontSize: 13, fontWeight: "bold", textTransform: "uppercase", letterSpacing: 1 }}>
            CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM
          </div>
          <div style={{ fontSize: 12, fontWeight: "bold" }}>Độc lập – Tự do – Hạnh phúc</div>
          <div style={{ width: 140, borderTop: "1px solid #111", margin: "6px auto 16px" }} />

          <div style={{ fontSize: 18, fontWeight: "bold", color: "#0f172a", textTransform: "uppercase" }}>
            BIÊN BẢN CHỨNG NHẬN GIAO KẾT HỢP ĐỒNG ĐIỆN TỬ
          </div>
          <div style={{ fontSize: 12, fontStyle: "italic", color: "#475569" }}>
            (ELECTRONIC SIGNATURE AUDIT TRAIL CERTIFICATE)
          </div>
          <div style={{ marginTop: 6, fontSize: 13 }}>
            Số hợp đồng: <b>{contractCode}</b> — Thời điểm hoàn tất giao kết:{" "}
            <b>{data.managerSignedAt ? new Date(data.managerSignedAt).toLocaleString("vi-VN") : "Đang chờ ký"}</b>
          </div>
        </div>

        {/* Nội dung 2 bên ký */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20, marginBottom: 20 }}>
          {/* Bên B */}
          <div
            style={{
              border: "1px solid #cbd5e1",
              borderRadius: 6,
              background: "#fff",
              padding: "16px",
            }}
          >
            <div style={{ fontWeight: "bold", fontSize: 14, color: "#1677ff", marginBottom: 8, borderBottom: "1px solid #f1f5f9", paddingBottom: 4 }}>
              BÊN B: NGƯỜI LAO ĐỘNG
            </div>
            <table style={{ width: "100%", fontSize: 12, lineHeight: 1.8 }}>
              <tbody>
                <tr>
                  <td style={{ color: "#64748b", width: "40%" }}>Họ và tên:</td>
                  <td style={{ fontWeight: "bold" }}>{employeeName}</td>
                </tr>
                <tr>
                  <td style={{ color: "#64748b" }}>Số CCCD/CMND:</td>
                  <td>{data.idNumber || "—"}</td>
                </tr>
                <tr>
                  <td style={{ color: "#64748b" }}>Email xác thực:</td>
                  <td>
                    {data.personnel?.email ||
                      data.personnel?.fast_contact_email ||
                      (data.employeeEmail && !data.employeeEmail.endsWith("@cis.com.vn") ? data.employeeEmail : null) ||
                      (data.employee_email && !data.employee_email.endsWith("@cis.com.vn") ? data.employee_email : null) ||
                      data.employeeEmail ||
                      data.email ||
                      "—"}
                  </td>
                </tr>
                <tr>
                  <td style={{ color: "#64748b" }}>Phương thức:</td>
                  <td style={{ color: "#16a34a", fontWeight: "bold" }}>✓ Xác thực OTP qua Email</td>
                </tr>
                <tr>
                  <td style={{ color: "#64748b" }}>Thời gian ký:</td>
                  <td>{data.employeeSignedAt ? new Date(data.employeeSignedAt).toLocaleString("vi-VN") : "Đang chờ ký"}</td>
                </tr>
                <tr>
                  <td style={{ color: "#64748b" }}>Địa chỉ IP ký:</td>
                  <td>{data.ipAddress || data.signer_ip || "127.0.0.1 (Nội bộ)"}</td>
                </tr>
                <tr>
                  <td style={{ color: "#64748b" }}>Trạng thái:</td>
                  <td style={{ color: "#16a34a", fontWeight: "bold" }}>
                    {data.employeeSignature ? "✓ Đã hoàn tất ký" : "Chờ ký"}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Bên A */}
          <div
            style={{
              border: "1px solid #cbd5e1",
              borderRadius: 6,
              background: "#fff",
              padding: "16px",
            }}
          >
            <div style={{ fontWeight: "bold", fontSize: 14, color: "#dc2626", marginBottom: 8, borderBottom: "1px solid #f1f5f9", paddingBottom: 4 }}>
              BÊN A: NGƯỜI SỬ DỤNG LAO ĐỘNG
            </div>
            <table style={{ width: "100%", fontSize: 12, lineHeight: 1.8 }}>
              <tbody>
                <tr>
                  <td style={{ color: "#64748b", width: "40%" }}>Đại diện:</td>
                  <td style={{ fontWeight: "bold" }}>{managerName || "Phạm Thị Thu Lan"}</td>
                </tr>
                <tr>
                  <td style={{ color: "#64748b" }}>Chức vụ:</td>
                  <td>{company?.repTitle || "Giám đốc"}</td>
                </tr>
                <tr>
                  <td style={{ color: "#64748b" }}>Đơn vị:</td>
                  <td>{company?.companyName || "CÔNG TY CP TM DV CIS"}</td>
                </tr>
                <tr>
                  <td style={{ color: "#64748b" }}>Phương thức:</td>
                  <td style={{ color: "#dc2626", fontWeight: "bold" }}>★ Ký số & Con dấu pháp nhân</td>
                </tr>
                <tr>
                  <td style={{ color: "#64748b" }}>Thời gian ký:</td>
                  <td>{data.managerSignedAt ? new Date(data.managerSignedAt).toLocaleString("vi-VN") : "Đang chờ ký"}</td>
                </tr>
                <tr>
                  <td style={{ color: "#64748b" }}>Mã số thuế:</td>
                  <td>{company?.certificate || "0110948453"}</td>
                </tr>
                <tr>
                  <td style={{ color: "#64748b" }}>Trạng thái:</td>
                  <td style={{ color: "#dc2626", fontWeight: "bold" }}>
                    {data.managerSignature ? "★ Đã duyệt & đóng dấu" : "Chờ duyệt"}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Dòng thời gian chứng nhận (Timeline) */}
        <div style={{ marginBottom: 20 }}>
          <div style={{ fontWeight: "bold", fontSize: 13, marginBottom: 10, color: "#0f172a" }}>
            NHẬT KÝ SỰ KIỆN GIAO KẾT (AUDIT LOGS)
          </div>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 11.5 }}>
            <thead>
              <tr style={{ background: "#f1f5f9", textAlign: "left" }}>
                <th style={{ border: "1px solid #cbd5e1", padding: "6px 10px" }}>Thời gian</th>
                <th style={{ border: "1px solid #cbd5e1", padding: "6px 10px" }}>Chủ thể</th>
                <th style={{ border: "1px solid #cbd5e1", padding: "6px 10px" }}>Hành động</th>
                <th style={{ border: "1px solid #cbd5e1", padding: "6px 10px" }}>Chi tiết kỹ thuật</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ border: "1px solid #cbd5e1", padding: "6px 10px" }}>
                  {data.date_created ? new Date(data.date_created).toLocaleString("vi-VN") : (data.created_at ? new Date(data.created_at).toLocaleString("vi-VN") : "—")}
                </td>
                <td style={{ border: "1px solid #cbd5e1", padding: "6px 10px", fontWeight: "bold" }}>Hệ thống</td>
                <td style={{ border: "1px solid #cbd5e1", padding: "6px 10px" }}>Khởi tạo hợp đồng</td>
                <td style={{ border: "1px solid #cbd5e1", padding: "6px 10px", color: "#64748b" }}>Tạo mã {contractCode} trên hệ thống ERP CIS</td>
              </tr>
              {data.employeeSignedAt && (
                <tr>
                  <td style={{ border: "1px solid #cbd5e1", padding: "6px 10px" }}>
                    {new Date(data.employeeSignedAt).toLocaleString("vi-VN")}
                  </td>
                  <td style={{ border: "1px solid #cbd5e1", padding: "6px 10px", fontWeight: "bold", color: "#16a34a" }}>
                    {employeeName}
                  </td>
                  <td style={{ border: "1px solid #cbd5e1", padding: "6px 10px" }}>Ký điện tử & Xác thực OTP</td>
                  <td style={{ border: "1px solid #cbd5e1", padding: "6px 10px", color: "#64748b" }}>
                    Xác thực mã OTP 6 số thành công qua email
                  </td>
                </tr>
              )}
              {data.managerSignedAt && (
                <tr>
                  <td style={{ border: "1px solid #cbd5e1", padding: "6px 10px" }}>
                    {new Date(data.managerSignedAt).toLocaleString("vi-VN")}
                  </td>
                  <td style={{ border: "1px solid #cbd5e1", padding: "6px 10px", fontWeight: "bold", color: "#dc2626" }}>
                    {managerName || "Đại diện công ty"}
                  </td>
                  <td style={{ border: "1px solid #cbd5e1", padding: "6px 10px" }}>Ký số phê duyệt & Đóng dấu</td>
                  <td style={{ border: "1px solid #cbd5e1", padding: "6px 10px", color: "#64748b" }}>
                    Xác thực mã PIN bảo mật con dấu pháp nhân thành công
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Tính toàn vẹn mật mã & QR code */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", background: "#fff", border: "1px solid #cbd5e1", borderRadius: 6, padding: "12px 16px" }}>
          <div style={{ flex: 1, marginRight: 20 }}>
            <div style={{ fontWeight: "bold", fontSize: 12, color: "#0f172a", marginBottom: 4 }}>
              MÃ BĂM TÍNH TOÀN VẸN VĂN BẢN (DOCUMENT SHA-256 HASH):
            </div>
            <div
              style={{
                fontFamily: "monospace",
                fontSize: 11,
                background: "#f1f5f9",
                padding: "6px 10px",
                borderRadius: 4,
                wordBreak: "break-all",
                color: "#0f172a",
                fontWeight: "bold",
                border: "1px solid #e2e8f0",
              }}
            >
              {docHash}
            </div>
            <div style={{ fontSize: 11, color: "#64748b", marginTop: 8 }}>
              * Căn cứ Điều 14 Bộ luật Lao động 2019 và Luật Giao dịch điện tử số 20/2023/QH15, văn bản này đã được
              các bên hoàn tất giao kết điện tử hợp pháp và có giá trị thi hành như văn bản gốc ký giấy.
            </div>
          </div>

          {/* QR Code tra cứu */}
          <div style={{ textAlign: "center", width: 120 }}>
            <div style={{ padding: 4, background: "#fff", border: "1px solid #cbd5e1", borderRadius: 6, display: "inline-block" }}>
              <QRCode value={verifyUrl} size={90} bordered={false} />
            </div>
            <div style={{ fontSize: 10, color: "#64748b", marginTop: 4 }}>Quét mã QR tra cứu tính toàn vẹn</div>
          </div>
        </div>
      </div>
    </div>
  );
}
